import React, { useEffect, useState } from "react";
import "./Banner.css";
import imgCircle from "../../assets/image/circle-mundu.png";

const Banner = (props) => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 100) {
        const newRotation = scrollY / 2;
        setRotation(newRotation);
      } else {
        setRotation(0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const imgStyle = {
    transform: `rotate(${rotation}deg)`,
  };

  return (
    <>
      <div className='box-banner w-full lg:px-10 flex items-center justify-center relative lg:pt-24 md:pt-24 overflow-hidden sm:pt-24 lg:mt-24 md:mt-24'>
        <div className='box-anggota-profile flex w-full '>
          <div className='title-banner px-8  items-center flex sm:px-6'>
            <p className='sm:text-lg lg:max-w-7xl md:text-2xl capitalize'>
             {props.data.description}
            </p>
            {/* <p className='sm:text-lg lg:max-w-7xl md:text-2xl capitalize'>
              untuk digitalisasi yang lebih baik, dan inovatif
            </p> */}
          </div>
          <img
            src={imgCircle}
            alt=''
            srcset=''
            className='img-spinner spinnerClassName'
            style={imgStyle}
          />
        </div>
      </div>
    </>
  );
};

export default Banner;
